'use strict'

const header =  {
    el: {
        html          : document.querySelector('html'),
        body          : document.body,
        voile         : document.querySelector('.voile'),
        logo          : document.querySelector('.header_logo'),
        navBtn        : document.getElementById('nav_toggle'),
        navWrap       : document.getElementById('nav_mobile'),
        nav           : document.getElementById('nav'),
        mainItem      : document.querySelectorAll('#nav_mobile #menu-main > .menu-item'),
        mainItemA     : document.querySelectorAll('#nav_mobile #menu-main > .menu-item > a'),
        mainItemMobA  : document.querySelectorAll('#nav_mobile #menu-main .noclic .menu-item-main > a'),
        parentItem    : document.querySelectorAll('#nav_mobile #menu-main > .menu-item-has-children'),
        aItem         : document.querySelectorAll('#nav_mobile #menu-main > .menu-item-has-children > a'),
        subs          : document.querySelectorAll('#nav_mobile #menu-main > .menu-item-has-children > .sub-menu'),
        childItem     : document.querySelectorAll('#nav_mobile #menu-main > .menu-item-has-children > .sub-menu > .menu-item-has-children'),
        childItemA     : document.querySelectorAll('#nav_mobile #menu-main > .menu-item-has-children > .sub-menu > .menu-item-has-children > a'),
        subs2         : document.querySelectorAll('#nav_mobile #menu-main > .menu-item-has-children .sub-sub-menu'),
        socialToggle  : document.querySelector('.sticky_social-toggle'),
        socialList    : document.querySelector('.sticky_social-list'),
    },
    
    init: function(){
        header.events();
        header.setSubStyle();
    },

    events: function() {
        // click sur le menu burger sur mobile
        if(header.el.navBtn) {
            header.el.navBtn.addEventListener('click', function() {
                header.toggleNav();
            });
        }
        
        // hover sur un item du menu ayant un sous-menu
        if(header.el.parentItem) {
            header.el.parentItem.forEach(e => {
                e.addEventListener('mouseenter', function() { header.toggleVoile(true); });
                header.el.nav.addEventListener('mouseleave', function() {header.toggleVoile(false);});
            });
        }

        // click sur un item du menu ayant un sous-menu
        if(header.el.aItem) {
            header.el.aItem.forEach(e => {
                e.addEventListener('click', function(event) {
                    if(window.matchMedia("(max-width: 1099px)").matches) {
                        event.preventDefault();
                    }
                    header.toggleSubNav(e.parentElement);
                });
            });
        }
        //console.log(header.el.mainItemMobA);
        if(header.el.mainItemMobA) {
            header.el.mainItemMobA.forEach(e => {
                e.addEventListener('click', function(event) {
                    event.preventDefault();
                });
            });
        }

        // click sur un item du sous-menu ayant un sous-menu
        if(header.el.childItemA) {
            header.el.childItemA.forEach(e => {
                e.addEventListener('click', function() { header.toggleSub2Nav(e.parentNode); });
            });
        }
        //console.log(header.el.mainItemA)
        header.el.mainItemA.forEach(e => {
            e.addEventListener('click', function(event) {
                if(e.parentNode.classList.contains('noclic')) {
                    event.preventDefault();
                }
            });
        });
    },

    // ouverture et fermeture de la navigation mobile
    toggleNav: function() {
        let html = header.el.html;
        let body = header.el.body;
        let nav = header.el.navWrap;
        let height = window.innerHeight;
        
        if (html.classList.contains('nav-open')) {
            html.classList.remove('nav-open');
            setTimeout(() => {
                nav.style.display = 'none';
                nav.style.height = 'none';
                html.style.height = '';
                body.style.height = '';
                document.querySelector('.header_wrapMobile').classList.remove('search_opened');
            }, 250);
        }
        else {
            nav.style.display = 'block';
            nav.style.height = height + 'px';
            html.style.height = height + 'px';
            body.style.height = height + 'px';
            setTimeout(() => {
                html.classList.add('nav-open');
            }, 50);
        }
    },

    setSubStyle: function() {
        if(window.matchMedia("(min-width: 1100px)").matches) {
            header.el.parentItem.forEach(item => {
                let left = item.offsetLeft;
                let sub = item.querySelector('.sub-menu');
                sub.style.paddingLeft = left + 15 + 'px';
            });
        }
    },

    toggleSubNav: function(item) {
        if(window.matchMedia("(max-width: 1099px)").matches) {
            if(item.classList.contains('sub_opened')) {
                item.classList.remove('sub_opened');
                header.el.logo.style.display = 'block';
                header.el.nav.parentElement.classList.remove('sub_isOpened');
                if(header.el.childItem) {
                    header.el.childItem.forEach(e => {
                        e.classList.remove('sub2_opened');
                    });
                }
            }
            else {
                item.classList.add('sub_opened');
                header.el.nav.parentElement.classList.add('sub_isOpened');
                header.el.logo.style.display = 'none';
            }
        }
    },

    toggleSub2Nav: function(item) {
        if(window.matchMedia("(max-width: 1099px)").matches) {
            event.preventDefault();
            item.classList.contains('sub2_opened') ? item.classList.remove('sub2_opened') : item.classList.add('sub2_opened');
        }
    },

    toggleVoile: function(toggle) {
        if(window.matchMedia("(min-width: 1099px)").matches) {
            let html = header.el.html;
            let voile = header.el.voile;
        
            if(toggle == false) {
                html.classList.remove('dark');
                voile.style.opacity = 0;
                setTimeout(() => {
                    voile.style.display = 'none';
                }, 500);
            }
            else {
                html.classList.add('dark');
                voile.style.display = 'block';
                setTimeout(() => {
                    voile.style.opacity = .7;
                }, 50);
            }
        }
    },

    toggleNavOnResize: function() {
        if(window.matchMedia("(min-width: 1100px)").matches) {
            let html = header.el.html;
            let body = header.el.body;
            let nav = header.el.navWrap;
            if (html.classList.contains('nav-open')) {
                html.classList.remove('nav-open');
                nav.style.display = '';
                nav.style.height = '';
                html.style.height = '';
                body.style.height = '';
            }
        }
    },
}


export default header;


// WEBPACK FOOTER //
// ./src/scripts/components/header.js